
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {ProjectProps} from "types/props-obj/ProjectProps";

const initialState: ProjectProps = {
  apiEndPoint: "project",
  pageLimit: 25,
  pageNumber: 1,
  isOpen: false,
  list: [],
  item: null,
  error: null,
  alertPopup: false
};

const project = createSlice({
  name: initialState.apiEndPoint,
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload.error;
    },
    setPageNumber(state, action) {
      state.pageNumber = action.payload;
    },
    setPageLimit(state, action) {
      state.pageLimit = action.payload;
    },
    // get all Item list
    getList(state, action) {
      state.list.push(action.payload);
      state.list = state.list.filter((liste) => liste.id !== 0);
    },
    alertPopupToggle(state, action) {
      state.alertPopup = action.payload.alertPopup;
    },
    openToggle(state, action) {

      state.isOpen = action.payload.isOpen;
    },
    // get Item details
    setItem(state, action) {
      state.item = action.payload;
    },

    // GET Items
    setItemsSuccess(state, action) {
      state.list = action.payload.data;
      state.current_page=action.payload.current_page;
      state.last_page=action.payload.last_page;
      state.total=action.payload.total
    },

    // ADD Item
    addItemSuccess(state, action) {
      state.list = [...state.list,action.payload];
    },

    

    // EDIT Item
    editItemSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
      state.item=action.payload;
      state.list[foundIndex] = action.payload;
    },

    deleteItemSuccess(state, action) {
      state.list = state.list.filter((item) => item.id !== action.payload);
    },



    setApiEndPoint(state, action) {
      state.apiEndPoint = action.payload;
    },


  }
});


export default project.reducer;

function getApiEndPoint(){
  return store.getState().project.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setPageLimit,setApiEndPoint } = project.actions;
export function getList(params:any={}) {
  return async () => {
    try {
      const response = await axios.get(getApiEndPoint(),{params:params});
      dispatch(project.actions.setItemsSuccess(response.data));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}

export function getItem(id: number | undefined) {
  return async () => {
    try {
      const response = await axios.get([getApiEndPoint(),  id].join('/'));
      dispatch(project.actions.setItem(response.data));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}

export function addItem(ls:any) {
  return async () => {
    try {
      const response = await axios.post(getApiEndPoint(), ls);
      dispatch(project.actions.addItemSuccess(response.data));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}

export function editItem(id: number | undefined,ls: any) {
  return async () => {
    try {
      const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
      dispatch(project.actions.editItemSuccess(response.data));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}

export function deleteItem(id: number | undefined) {
  return async () => {
    try {
      await axios.delete([getApiEndPoint(),  id].join('/'));
      dispatch(project.actions.deleteItemSuccess(id));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}


export function addJobCard(ls:any) {
  return async () => {
    try {
      // const response = 
      await axios.post('job-card', ls);
      // dispatch(project.actions.addItemSuccess(response.data));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}

export function sendCustomerEmail(id:number,ls:any) {
  return async () => {
    try {
      const response = await axios.post([getApiEndPoint(),  id,'send-customer-email'].join('/'), ls,{headers:{'Content-Type': 'multipart/form-data'}});
      dispatch(project.actions.setItem(response.data));
    } catch (error) {
      dispatch(project.actions.hasError(error));
    }
  };
}